(function () {
	// globals
	EWO.ToolUsers = {};

	// utility functions
	function handleFileSelect(event) {
		const file = event.target.files[0];
		const importBtn = $('.js-import-sections');
		importBtn.prop('disabled', !file);
	}

	// app functions
	EWO.ToolUsers.rederToolUsers = function (ctx) {
		var urlQueryString = new URLSearchParams(ctx.querystring);
		var filter = Object.fromEntries(urlQueryString);
		$.extend(filter, ctx.params);
		$.get('/version.json')
			.done(function (version) {
				$('.js-page-container').html(ejs.rr('/app/election/operations/templates/toolUsers.ejs', { version: version }));
				refreshUsers();
			});

		EWO.ToolUsers.filter = filter;
	}
	async function refreshUsers() {
		const electionId = EWO.ToolUsers.filter.electionId;
		EWO.ToolUsers.filter.allUsers = [];
		const allUsers = EWO.ToolUsers.filter.allUsers;
		$('.js-users-log-content').text("Loading...");
		try {

			const response = await $.ajax({
				url: `/api/v1/Boundaries?electionId=${electionId}`,
				type: 'GET'
			});
			allUsers.push(...response.rows);

			renderLogUsersFiltered(allUsers, '');
		} catch (error) {
			// Gestione degli errori
			console.error('Errore durante il recupero dei dati:', error);
		}
	}
	function renderLogUsersFiltered(allUsers, filter) {
		const logUsers = [];
		const header = ['idUser', 'username', 'email', 'constituency'];
		const columnWidths = [10, 20, 30, 20]; // Larghezza di ogni colonna

		// Aggiungi l'intestazione con padding
		logUsers.push(header.map((col, index) => col.padEnd(columnWidths[index])).join('\t'));

		const usersFiltered = allUsers.filter(user => user.username.toUpperCase().includes(filter.toUpperCase()));
		for (const user of usersFiltered) {
			// Aggiungi ogni riga con padding
			logUsers.push([
				user.id.toString().padEnd(columnWidths[0]),
				user.username.padEnd(columnWidths[1]),
				user.email?user.email.padEnd(columnWidths[2]):'-'.padEnd(columnWidths[2]),
				user.municipalityDesc.padEnd(columnWidths[3])
			].join('\t'));
		}
		logUsers.push('');
		logUsers.push(`Numero totale di utenti: ${usersFiltered.length}`);
		const logContentUsers = logUsers.map(line => line.trim()).join('\n');
		$('.js-users-log-content').text(logContentUsers);
	
	}
	// funzione che aggiunge una riga rossa .js-users-log-content la riga è un input
	function logUserSendResult(riga,type='secondary') {
		// aggiungo a .js-users-log-content la riga
		$('.js-users-log-content').append(`<div class="alert alert-${type}">${riga}</div>`);
		// scrolla verso l'ultima riga
	    $('.js-users-log-container').scrollTop($('.js-users-log-container')[0].scrollHeight);
	}
	// events

	// Aggiungi handler per generazione utenti
	$(document).on('click', '.js-generate-users-comunali', function (ev) {
		ev.preventDefault();
		const electionId = EWO.ToolUsers.filter.electionId;
		const prefix = $('.js-user-prefix').val();
		const usersPerMunicipality = $('.js-users-per-municipality').val();
		const language = $('.js-user-language').val();
		console.log('generate users comunali');
		console.log(electionId, prefix, usersPerMunicipality, language);

		$.ajax({
			url: `/api/v1/Elections/createMuniUsers/${electionId}?nrUserEachMuni=${usersPerMunicipality}&defaultLang=${language}&prefixNamepart=${prefix}`,
			type: 'POST',
			success: function (response) {
				alert(i18next.t('Utenti generati con successo'));
			},
			error: function () {
				alert(i18next.t('Errore durante la generazione degli utenti'));
			}
		});
	});

	$(document).on('click', '.js-generate-users-circondariali', function (ev) {
		ev.preventDefault();
		const electionId = EWO.ToolUsers.filter.electionId;
		const prefix = $('.js-user-prefix').val();
		const usersPerMunicipality = $('.js-users-per-municipality').val();
		const language = $('.js-user-language').val();
		console.log('generate users circondariali');
		console.log(electionId, prefix, usersPerMunicipality, language);

		$.ajax({
			url: `/api/v1/Elections/createCommitteeUsers/${electionId}?nrUserEachMuni=${usersPerMunicipality}&defaultLang=${language}&prefixNamepart=${prefix}`,
			type: 'POST',
			success: function (response) {
				alert(i18next.t('Utenti generati con successo'));
			},
			error: function () {
				alert(i18next.t('Errore durante la generazione degli utenti'));
			}
		});

	});




	//routes
	page('/election/:electionId/toolUsers', EWO.ToolUsers.rederToolUsers);


})();
// test